import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJug = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M13.91,8.88V5.32H9.14V8.88a4.31,4.31,0,0,1-1.73,3.46l-.36.27a4.33,4.33,0,0,0-1.73,3.46h0a4.23,4.23,0,0,0,.22,1.37L7.23,22.5h8.59l1.69-5.06a4.52,4.52,0,0,0,.22-1.37h0A4.33,4.33,0,0,0,16,12.61l-.36-.27A4.31,4.31,0,0,1,13.91,8.88Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 8.18,
			y: 1.5,
			width: 6.68,
			height: 3.82
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M16.4,13a2.39,2.39,0,0,0-.1-4.77A2.41,2.41,0,0,0,14,9.85"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 9.14,
			y: 14.86,
			width: 4.77,
			height: 3.82
		})
	]
});
const ForwardRef = forwardRef(SvgJug);
export default ForwardRef;
